import { useState, useEffect } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

import CarouselMovies from "./CarouselMovies";

const key = "b55d580200c51623fe9608f8f064a09b";

const MoviePage = () => {
  const navigate = useNavigate();

  const params = useParams();
  const [movieById, setMovieById] = useState("");
  const [movieBgById, setMovieBgById] = useState("");

  const starsDefault = [
    "fa-regular fa-star fa-lg red-star",
    "fa-regular fa-star fa-lg red-star",
    "fa-regular fa-star fa-lg red-star",
    "fa-regular fa-star fa-lg red-star",
    "fa-regular fa-star fa-lg red-star",
  ];
  const setingColorStars = (whichStar) => {
    setStarsColor(() => {
      const aux = [...starsDefault];
      for (let i = 0; i < whichStar; i++) {
        aux[i] = "fa-solid fa-star fa-lg red-star";
      }
      return aux;
    });
  };
  const [starsColor, setStarsColor] = useState([]);

  useEffect(() => {
    setMovieById("");
    const getMoviesById = async () => {
      const response = await axios.get(
        `https://api.themoviedb.org/3/movie/${params.id}?api_key=${key}&language=en-US`
      );
      const movieData = response.data;
      setMovieById(movieData);
    };
    const getMovieBg = async () => {
      const response = await axios.get(
        `https://api.themoviedb.org/3/movie/${params.id}/images?api_key=${key}`
      );
      const data = response.data.backdrops[0];
      setMovieBgById(data.file_path);
    };
    getMovieBg();
    getMoviesById();
  }, [params.id]);

  useEffect(() => {
    setingColorStars(Math.floor(movieById.vote_average) / 2);
  }, [movieById]);

  return (
    <>
      {!movieById && (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ width: "100%", height: "100vh" }}
        >
          <CircularProgress color="secondary" />
        </div>
      )}
      {movieById && (
        <>
          <div
            className="movie-bg d-flex align-items-center justify-content-center flex-column"
            // style={{
            //   backgroundImage: `url("https://image.tmdb.org/t/p/w500/${movieById.poster_path}")`,
            // }}
            style={{
              backgroundImage: `url("https://image.tmdb.org/t/p/original/${movieBgById}")`,
              minHeight: "100vh",
            }}
          >
            <div className="miModal container">
              <div className="miModal-content p-4 d-flex">
                <div className="">
                  <div className="miModal__img-container">
                    <img
                      src={`https://image.tmdb.org/t/p/w500/${movieById.poster_path}`}
                      alt={`Poster from ${movieById.title}`}
                    />
                  </div>
                </div>
                <div className="ms-4 text-start d-flex flex-column justify-content-between">
                  <div className="moviePage__header">
                    <h1 className="miModal__title mb-2 fw-bold">
                      {`${movieById.original_title} `}
                      <span className="miModal__rating fw-light fs-5">
                        ({movieById.vote_average})
                      </span>
                    </h1>

                    <div className="movieGenres mb-2">
                      {movieById && movieById.genres[0].name} -{" "}
                      {movieById && movieById.runtime}min
                    </div>
                    <div className="filtro d-flex align-items-center">
                      <span className="filtro__icons__moviePage d-flex">
                        <div>
                          <i className={starsColor[0]}></i>
                        </div>
                        <div>
                          <i className={starsColor[1]}></i>
                        </div>
                        <div>
                          <i className={starsColor[2]}></i>
                        </div>
                        <div>
                          <i className={starsColor[3]}></i>
                        </div>
                        <div>
                          <i className={starsColor[4]}></i>
                        </div>
                      </span>
                    </div>
                  </div>

                  <div className="overview">
                    <h4>Overview:</h4>
                    <p>{movieById.overview}</p>
                  </div>

                  <div
                    className="moviepage__footer"
                    // style={{ height: "100%" }}
                  >
                    <h6 className="mb-2">Produced by</h6>
                    <div className="d-flex">
                      <div className="companies_moviePage py-2 px-1">
                        {movieById &&
                          movieById.production_companies.map(
                            (companie, index) => {
                              if (
                                `https://image.tmdb.org/t/p/w500/${companie.logo_path}`.match(
                                  /\.(jpeg|jpg|gif|png)$/
                                )
                              ) {
                                return (
                                  <img
                                    style={{
                                      maxWidth: "48px",
                                      maxHeight: "50px",
                                    }}
                                    src={`https://image.tmdb.org/t/p/w500/${companie.logo_path}`}
                                    alt={`Logo from ${companie.name}`}
                                    className="mx-3"
                                    key={companie.id}
                                  />
                                );
                              }
                            }
                          )}
                      </div>
                    </div>
                    <div className="miModal__btn-container pt-2 d-flex justify-content-end align-items-center">
                      {/* <div className="scrollToSimilar text-muted d-flex align-items-center pt-2">
                    <i className="fa-solid fa-arrow-down fa-xs pe-1 mt-1"></i>
                    <span style={{ fontSize: "14px" }}>
                      View similar movies
                    </span>
                  </div> */}

                      <button
                        type="button"
                        className="playBtn rounded py-1 d-flex align-items-center justify-content-center"
                        onClick={() => {
                          window.scrollTo(0, 0);
                          navigate(`/watch/${movieById.id}`);
                        }}
                      >
                        PLAY
                        <i className="ms-2 fa-solid fa-play"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div
                className="scrollToSimilar text-secondary d-flex align-items-center pt-3 ms-2"
                onClick={() =>
                  window.scrollTo({
                    top: document.documentElement.scrollHeight,
                    behavior: "smooth",
                  })
                }
              >
                <i className="fa-solid fa-arrow-down fa-sm pe-1 mt-1"></i>
                <span>View similar movies</span>
              </div>
            </div>
          </div>
          {/* res-----------------------------------  */}
          <div className="miModal-res">
            <div
              className="miModal-content-res pt-4 p-2 d-flex flex-column align-items-center"
              style={{
                backgroundImage: `url("https://image.tmdb.org/t/p/original/${movieById.poster_path}")`,
              }}
            >
              <div className="moviePage__title-res " style={{ width: "100%" }}>
                <h1 className="miModal__title text-start mb-3 mx-2 fw-bold">
                  {`${movieById.original_title} `}
                  <span className="miModal__rating fw-light fs-5">
                    ({movieById.vote_average})
                  </span>
                </h1>

                <div className="miModal__img-container-res mx-2">
                  <img
                    src={`https://image.tmdb.org/t/p/original/${movieBgById}`}
                    alt={`Backdrop from ${movieById.title}`}
                  />
                </div>
              </div>
              <div
                className="text-start d-flex flex-column justify-content-between"
                style={{ height: "100%" }}
              >
                <div className="moviePage__header mt-2 mx-3 d-flex justify-content-between align-items-center">
                  <div className="filtro d-flex align-items-start">
                    <span className="filtro__icons__moviePage d-flex ">
                      <div>
                        <i className={starsColor[0]}></i>
                      </div>
                      <div>
                        <i className={starsColor[1]}></i>
                      </div>
                      <div>
                        <i className={starsColor[2]}></i>
                      </div>
                      <div>
                        <i className={starsColor[3]}></i>
                      </div>
                      <div>
                        <i className={starsColor[4]}></i>
                      </div>
                    </span>
                  </div>
                  <div className="movieGenres ">
                    {movieById && movieById.genres[0].name} -{" "}
                    {movieById && movieById.runtime}min
                  </div>
                </div>

                <div className="overview mx-3 mt-1">
                  <h4>Overview:</h4>
                  {movieById &&
                    // movieById.overview.length > 450 &&
                    movieById.overview.length > 421 && (
                      <p style={{ fontSize: "12px" }}>{movieById.overview}</p>
                    )}
                  {movieById &&
                    movieById.overview.length < 420 &&
                    movieById.overview.length > 360 && (
                      <p style={{ fontSize: "13px" }}>{movieById.overview}</p>
                    )}
                  {movieById &&
                    movieById.overview.length > 315 &&
                    movieById.overview.length < 359 && (
                      <p style={{ fontSize: "14px" }}>{movieById.overview}</p>
                    )}
                  {movieById && movieById.overview.length < 314 && (
                    <p>{movieById.overview}</p>
                  )}

                  {/* <p>{movieById.overview}</p> */}
                </div>

                <div
                  className="moviepage__footer"
                  // style={{ height: "100%" }}
                >
                  <h6 className="mb-2 mx-3">Produced by</h6>
                  <div className="d-flex mx-3">
                    <div className="companies_moviePage py-2 pe-1">
                      {movieById &&
                        movieById.production_companies.map(
                          (companie, index) => {
                            if (
                              `https://image.tmdb.org/t/p/w500/${companie.logo_path}`.match(
                                /\.(jpeg|jpg|gif|png)$/
                              )
                            ) {
                              return (
                                <img
                                  style={{
                                    maxWidth: "48px",
                                    maxHeight: "50px",
                                  }}
                                  src={`https://image.tmdb.org/t/p/w500/${companie.logo_path}`}
                                  alt={`Logo from ${companie.name}`}
                                  className="mx-3"
                                  key={companie.id}
                                />
                              );
                            }
                          }
                        )}
                    </div>
                  </div>
                  <div className="miModal__btn-container pt-3 pb-2 d-flex justify-content-between align-items-center">
                    <div
                      className="scrollToSimilar ms-3 text-muted d-flex align-items-center pt-2"
                      onClick={() =>
                        window.scrollTo({
                          top: document.documentElement.scrollHeight,
                          behavior: "smooth",
                        })
                      }
                    >
                      <i className="fa-solid fa-arrow-down fa-xs pe-1 mt-1"></i>
                      <span style={{ fontSize: "14px" }}>
                        View similar movies
                      </span>
                    </div>

                    <button
                      type="button"
                      className="playBtn rounded py-1 d-flex align-items-center justify-content-center"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(`/watch/${movieById.id}`);
                      }}
                    >
                      PLAY
                      <i className="ms-2 fa-solid fa-play"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ------------------------------------- */}
      <div className="similar-MoviePage">
        <div className="genre-section-container my-4 mt-5 ">
          <div className="title-genre d-flex align-items-baseline">
            <Link
              to={`/genre/${movieById && movieById.genres[0].id}`}
              style={{ textDecoration: "none" }}
              className="genreLink ms-2 mb-2 mt-0 pt-0"
            >
              <h3 className="genreTitle text-start mb-0 fs-4">
                More {movieById && movieById.genres[0].name} movies
              </h3>
            </Link>
            <span className="i-span ">
              <i className="ms-2 fa-solid fa-play fa-sm"></i>
              {/* <i className=" ms-1 fa-solid fa-arrow-right fa-sm"></i> */}
            </span>
          </div>
          {movieById && <CarouselMovies genreId={movieById.genres[0].id} />}
        </div>
      </div>
    </>
  );
};

export default MoviePage;
